import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import smstfeditor from './imgs/smstfeditor-raw.png';

class SMSTFEditor extends Component {
  render() {
    return (
      <div className="App-body-project">
        <h2>Small Multiples Sequence-Controlled Transfer Function Editor for Designers</h2>
        <h3>Nov. – Dec. 2021</h3>
        <input type="image" src={smstfeditor} alt="Small Multiples Sequence Editor User Interface"/>
        <h4>Introduction</h4>
        <p>Standard volume visualization systems focus on more advanced
          features, complicating the transfer function (TF) interface. This
          makes it difficult for new users such as designers, who are unfamiliar
          with transfer functions and 3D graphics, to understand how these
          systems work. We present a volume visualization system with a small
          multiples sequence-controlled transfer function editor (SMS TF Editor)
          that attempts to improve learnability and facilitate rapid
          prototyping, particularly idea generation. Based on uniformly
          partitioned sub-volumes, we display a small multiple (three images
          with different opacities) and a color picker for each sub-volume for
          user selection that control the opacity and color TFs, respectively.
          We provide an exploratory user study comparing our system to the
          standard separated graph-based opacity and color TF editor. Even
          though both designers preferred the standard TF editor, they had a
          considerably faster task completion time with our system. We also
          present a set of design recommendations for improving transfer
          function user interfaces’ learnability.<br /><br />
          View the paper&nbsp;
          <a href={process.env.PUBLIC_URL + "./smstfeditor.pdf"} target="_blank" rel="noopener noreferrer">
            here
          </a>. Slides from my presentation can be found&nbsp;
          <a href="https://docs.google.com/presentation/d/1_gkQrUFlwwHY_OQRajtbzcCAD-QLuH6JZnNOhBPmN5I/edit?usp=sharing"
          target="_blank" rel="noopener noreferrer">here
          </a>.
        </p>
        <h4>Overview</h4>
        <p>1.	Related Work<br />
          2.	Method<br />
          3.	Evaluation (User Study)<br />
          4.	Results<br />
          5.	Limitations and Future Work<br /><br />
          My own personal goals for SMS TF Editor were to get more experience
          figuring out how to improve existing user interfaces' usability,
          particularly improving the learnability of tools for target users.
        </p>
        <h4>Literature Review</h4>
        <p>When reading papers on design galleries for my advanced visualization
          class, I noticed that the design galleries visualization systems
          all showed options for the entire transfer function domain, which may
          potentially be affected by the central tendency bias [1]. Furthermore,
          these systems didn't leverage users' prior familiarity with visual
          computing interfaces. Interested in exploring new ways to decrease the
          time taken to segment and colorize 3D volume data, I came up with an
          idea of letting users quickly choose their preferred opacity settings
          from a small set of pre-selected options, and the color TF settings
          via a standard color wheel. This led me to further investigate the
          small multiples method for visual data exploration, which has
          primarily been used in systems built for knowledgable scientific
          users.
        </p>
        <h4>Method</h4>
        <p>Our approach starts by uniformly partitioning the data into n
          sub-volumes. For each sub-volume, the system will then display 3
          images (each with a different opacity) of that sub-volume for the user
          to choose from. The user can also modify the color of the displayed
          sub-volume using a standard color wheel picker. The selected opacity
          image and color for each sub-volume directly control the corresponding
          TFs, and the system displays the final 3D view upon user selection for
          each sub-volume. Essentially, we show a sequence of small multiples
          for each sub-volume, with the user determining the optimal opacity and
          color choices for each sub-volume. Ultimately, this approach
          sacrifices some of the finer precision in the standard TF editors for
          greater simplicity.<br />
          <br />
          The SMS TF Editor was implemented with WebGL and Javascript, building
          upon my advanced visualization class's volume visualization system
          that I implemented throughout the quarter.
        </p>
        <h4>Evaluation (User Study)</h4>
        <p>Please see the writeup for a detailed explanation of the user study evaluation.
        </p>
        <h4>Results</h4>
        <p>Please see the writeup for a detailed explanation of the results.
        </p>
        <p><br />Note: Since this project builds upon my advanced visualization
          class's project framework, I cannot publicly release the code due to
          academic integrity reasons. Please contact me if you want to see the
          code or have any questions!
        </p>
        <h4>References</h4>
        <p>[1]	M. Olkkonen, P. F. McCarthy, and S. R. Allred. The central
          tendency bias in color perception: Effects of internal and external
          noise. Journal of vision, 14(11):5–5, 2014.
        </p>
        <div className="App-body-project-buttons">
          <Link to="/crochetmatic">
            <button type="button">
              &#8249; Previous: CrochetMatic
            </button>
          </Link>
          <Link to="/work">
            <button type="button">
              Back to Portfolio
            </button>
          </Link>
          <Link to="/surfacebrush">
            <button type="button">
              Next: SurfaceBrush &#8250;
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default SMSTFEditor;
